import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import '../css/Register.css';
import Vas from '../Vas';

import { SetRequired,CheckFields } from 'utils-lib';

import { TextField, ExtendedButton,MessageBox,Checkbox,Loading,  EmailRepeatComponent, HoneyPot } from 'component-lib';

import { RequestAjaxClass, AccountsModel } from 'models-lib';

var moment = require('moment');
moment().format();

class RegisterExistingCustomer  extends Component {
    
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.AGB='';
        this.state.Daten='';
        this.state.Note1 = '';

        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)}, null);
        this.AccountsModel = new AccountsModel([this], null, this.Request);

        this.requiredEmailRepeat = true;

        Vas.clearLocalStorage();

        this.Config = Vas.Config.RegisterExistingCustomer;
        this.ConfigDataProtection = Vas.Config.DataProtection;
    }
    
    componentDidMount()
    {
      this.Request.setAuth(false);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setApiUrl(Vas.ApiUrl);
      

      let reqFields = [this.refs.customerId, this.refs.registrationCode];
      let reqCheckBox = [this.refs.AcceptPrivacy,this.refs.AcceptTariffTerms];
      
      if(this.Config.CheckIban === true){
        reqFields.push(this.refs.iban);
      }
      this.setState({ requiredFields:reqFields,
                      requiredCeckBox: reqCheckBox},()=>{
                        SetRequired.Set(this.state.requiredFields,null,this.state.requiredCeckBox,null,this.refs.EMailRepeat.returnFields());
                    });
    }

    Update(observer){
      this.setState({},()=>{
        if(observer === "AccountCreateConsistedCustomer"){
          Vas.GetView("RegisterSuccess",null,false);
           
        }
      });
    }
    
    handleChange = (event, index, value) => {
        this.setState({ value });
    }

    Register(){
      if(this.refs.HoneyPot.isFilled() === false){
        let filled = this.checkFields();
        
        if (filled === true){
          
          ReactDOM.render(<Loading modal={true} />,document.getElementById('messageContainer'));
          
          this.AccountsModel.Email = this.refs.EMailRepeat.Email.trim();

          this.AccountsModel.AccountCreateConsistedCustomer();
            
        }
      }
    }

    //#region checkFields
    checkFields(){
      let filled=false;
      if (this.state.requiredFields && this.state.requiredCeckBox ){
         
          let emailFields = [];
          
          if(this.requiredEmailRepeat === true){
            emailFields = this.refs.EMailRepeat.returnFields();
          }

          filled = CheckFields.CheckFields(this.state.requiredFields,null,this.state.requiredCeckBox,null,emailFields);
          
          if(filled[0] === false){
            if(this.requiredEmailRepeat === true){
              if(this.refs.EMailRepeat.returnFilled()[0] === true){
                if(this.refs.EMailRepeat.state.EmailValid === false){
                  ReactDOM.render(<MessageBox 
                    Message={Vas.Resources.Tooltips["Email"]} 
                    Title={Vas.Resources.Titles["Note"]} />
                      ,document.getElementById('messageContainer'));
                }else{
                  ReactDOM.render(<MessageBox 
                    Message={Vas.Resources.Labels["NotAllFields"]} 
                    Title={Vas.Resources.Titles["Note"]} />
                      ,document.getElementById('messageContainer'));
                }
              }else{
                ReactDOM.render(<MessageBox 
                  Message={Vas.Resources.Labels["NotAllFields"]} 
                  Title={Vas.Resources.Titles["Note"]} />
                    ,document.getElementById('messageContainer'));
              }
            }
            else{
              ReactDOM.render(<MessageBox 
              Message={Vas.Resources.Labels["NotAllFields"]} 
              Title={Vas.Resources.Titles["Note"]} />
                ,document.getElementById('messageContainer'));
            }
          }

          return filled[0]
       }
    }

    //#endregion
    
    AGBClick(){
        document.getElementById("ceckboxAGB").checked=true;
    }

    DatenClick(){
        document.getElementById("checkboxDaten").checked=true;
    }

    setMarketingPhone(marketing){
      let reqFields = this.state.requiredFields;
      if(marketing === true){
        reqFields.push(this.refs.phone);
        this.refs.phone.setState({ Label:this.refs.phone.props.Label+"*" , isrequired : true});
      }else{
        let idx = -1;
        for(let i = 0; i< reqFields.length; i++){
          if(reqFields[i] === this.refs.phone){
            idx = i;
          }
        }
        if(idx > -1){
          reqFields.splice(idx,1);
          this.refs.phone.setState({ Label:this.refs.phone.props.Label , isrequired : false});
        }
      }
      this.setState({requiredFields : reqFields});
    }

    render()
    {
      let iban = '';
      if(this.Config.CheckIban === true){
        iban = <TextField
        me={this}
        Editable={true}
        IsRequired={true}
        ref={"iban"}
        Id={"Iban"}
        Label={Vas.Resources.Labels["LastIbanFields"]}
        OnBlur={()=>{ if($("#Iban").val()){
            if($("#Iban").val().length === 4){
              this.AccountsModel.Iban = $("#Iban").val();
            }else{
              $("#Iban").val('');
              this.AccountsModel.Iban = $("#Iban").val();
              ReactDOM.render(<MessageBox 
                Message={Vas.Resources.Labels["IbanToShort"]} 
                Title={Vas.Resources.Titles["Note"]}
                Field={"Iban"} />
                  ,document.getElementById('messageContainer'));
            }
          }
        }} />
      }
        return (
          <div className={"RegisterExistingCustomerContainer"}>
            <div className={"form registerForm"}>
              <div>
                <h2>{Vas.Resources.Labels["RegisterExistingCustomer"]}</h2>
              <div/>
                
                  <div className={"RegisterExistingContainerLeft"} style={{textAlign:'justify'}}>
                      <div><p>{Vas.Resources.Labels["RequiredField"]}</p></div>
                  </div>
                  <div className={"RegisterExistingContainerLeft"}>
                    <div style={{ color:'red' }}>{this.state.Note1}</div>
                  </div>

                  <HoneyPot
                    ref={"HoneyPot"}
                  />
                  
                  <div>
                    <div className={"RegisterExistingContainerLeft"}>
                      <TextField
                        me={this}
                        Editable={true}
                        IsRequired={true}
                        ref={"customerId"}
                        Id={"customerId"}
                        Label={Vas.Resources.Labels["CustomerNr"]}
                        OnChange={()=>{ this.AccountsModel.CustomerNumber = $("#customerId").val();}} />
                    </div>
                    <div className={"RegisterExistingContainerRight"}>
                      <TextField
                        me={this}
                        Editable={true}
                        IsRequired={true}
                        ref={"registrationCode"}
                        Id={"registrationCode"}
                        Label={Vas.Resources.Labels["RegistrationCode"]}
                        OnChange={()=>{ this.AccountsModel.RegCode = $("#registrationCode").val();}} />
                    </div>
                  </div>
                  <div>
                    <div className={"RegisterExistingContainerLeft"}>
                      {iban}
                    </div>
                  </div>
                    
                  <div>

                  </div>
                    <div>
                    <EmailRepeatComponent
                      AppURL={Vas.ApplicationUrl}
                      ApiUrl={Vas.ApiUrl}
                      ApiKey={Vas.ApiKey}
                      ref={"EMailRepeat"}
                      Required = {this.requiredEmailRepeat}
                      ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
                      IconId={"EmailRepeatIcon"}/>
                    </div>

                    <div className={"RegisterExistingNoteEmailContainerLeft"} style={{ textAlign:"justify"}}>
                      <div id={"noteEmail"}>
                        <b>{Vas.Resources.Titles["Note"]}:</b> {Vas.Resources.Labels["NoteEmail"]}
                      </div>
                    </div>
                  <div>
                    <div className={"RegisterExistingContainerLeft"}>
                        <TextField 
                          Width={182} 
                          me={this} 
                          Id={"phone"} 
                          ref={"phone"}
                          Editable={true} 
                          IsRequired={false} 
                          Tooltip={Vas.Resources.Tooltips["Phone"]} 
                          Label={Vas.Resources.Labels["Phone"]} 
                          OnChange={()=>{ this.AccountsModel.Phone = $("#phone").val() ; }}
                          Modus={"TelNumber"} />
                    </div>
                    </div> 


                    <div id={"marketingComplience"} style={{ textAlign: 'left', paddingTop: '15px',float:"left" }}> <b>{Vas.Resources.Labels["MarketingComplience"]} </b>
                    <div style={{ marginTop: '-5px' }}>
                      <div className={"RegisterExistingAGBContainerLeft"}>
                        <br/>
                        <Checkbox 
                          ref={"MarketingMail"} 
                          Id={"ceckboxMarketingMail"} 
                          onClick={()=>{this.AccountsModel.MarketingMail = document.getElementById("ceckboxMarketingMail").checked;}} 
                          IsRequired={true} />
                        <label htmlFor="cbox">{Vas.Resources.Labels["MarketingComplienceMail"]} 
                        </label>
                      </div>
                    </div>
                    <div >
                      <div className={"RegisterExistingAGBContainerLeft"}>
                        <Checkbox 
                          ref={"MarketingPhone"} 
                          Id={"ceckboxMarketingPhone"} 
                          onClick={()=>{
                            this.AccountsModel.MarketingPhone = document.getElementById("ceckboxMarketingPhone").checked;
                            this.setMarketingPhone(document.getElementById("ceckboxMarketingPhone").checked);
                          }} 
                          IsRequired={true} />
                        <label htmlFor="cbox">{Vas.Resources.Labels["MarketingCompliencePhone"]} 
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className={"RegisterExistingAGBContainerLeft"}>
                        <Checkbox 
                          ref={"MarketingPost"} 
                          Id={"ceckboxMarketingPost"} 
                          onClick={()=>{this.AccountsModel.MarketingPost = document.getElementById("ceckboxMarketingPost").checked;}} 
                          IsRequired={true} />
                        <label htmlFor="cbox">{Vas.Resources.Labels["MarketingCompliencePost"]} 
                        </label>
                      </div>
                    </div>
                    </div>

                    <div>
                      <div className={"RegisterExistingAGBContainerLeft"} style={{ textAlign:'left' }}>
                      <Checkbox
                        ref={"AcceptPrivacy"}
                        Id={"checkboxAcceptPrivacy"}
                        onClick={()=>{this.setState({ AcceptPrivacys:$("#acceptPrivacy").val() });}} />
                        <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["AcceptPrivacy"]}*</div>
                      </div>
                    </div>
                    <div >
                      <div className={"RegisterExistingContainerLeft"}>
                      <ExtendedButton 
                            Usable={true} 
                            Text={Vas.Resources.Labels["ViewHere"]} 
                            OnClick={()=>{ window.open(Vas.ApplicationUrl+"/20_10_16_Hinweise_zur_Datenverarbeitung_und_zum_Datenschutz.pdf"); }} 
                            Id={"btoAcceptPrivacy"}
                            Width={170} />
                      </div>
                    </div>
                    <div className={"RegisterExistingAGBContainerLeft"} style={{ textAlign:'left' }}>
                      <Checkbox
                        ref={"AcceptTariffTerms"}
                        Id={"checkboxAcceptTariffTerms"}
                        onClick={()=>{this.setState({ AcceptTariffTerms:$("#acceptTariffTerms").val() });}} />
                        <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["AcceptTariffTerms"]}*</div>
                    </div>
                  </div>
                  <div >
                    <div className={"RegisterExistingContainerLeft"} style={{ height:'56px' }}>
                    <ExtendedButton 
                          Usable={true} 
                          Text={Vas.Resources.Labels["ViewHere"]} 
                          OnClick={()=>{ window.open(this.ConfigDataProtection.LinkTarifBestimmungen); }} 
                          Id={"btoAcceptTariffTerms"}
                          Width={170} />
                          <br />
                    </div>
                  </div>
                  <div>
                    <div className={"RegisterExistingContainerLeft"}>
                      <ExtendedButton
                      Id={"RegisterExistingCreate"}
                      className={"registerButton"}
                      Width={188}
                      Usable={true}
                      Text={Vas.Resources.Labels["Create"]}
                      OnClick={()=>{ this.Register();}}
                      style={{ margin: 25 }} />
                    </div>
                    <div className={"RegisterExistingContainerRight"}>
                      <ExtendedButton
                      Id={"RegisterExistingCancel"}
                      Width={186}
                      Usable={true}
                      Text={Vas.Resources.Labels["Cancel"]}
                      OnClick={()=>{ Vas.GetView("Home",null, false);}}
                      style={{ margin: 25 }} />
                    </div>
                  </div>
                
                <div id={"fields"}></div>
              </div>
            </div>
          
        );
    }
}
export default RegisterExistingCustomer;
